import { Divider, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { ProductItem, ProductTotal } from '../../components';
import { useCheckoutState } from '../../store';

export const PlansMyProducts = () => {
  const { t } = useTranslation('checkout/plans');

  const { selectedPlans, setSelectedPlans } = useCheckoutState();

  const handleDeleteItem = (id: string) => {
    const planWithoutCurrent = selectedPlans.filter(plan => plan.id !== id);
    setSelectedPlans(planWithoutCurrent);
  };

  const total = selectedPlans.reduce(
    (acc, plan) => acc + plan.amountPrice * plan.quantity,
    0,
  );

  return (
    <Flex
      flexDir="column"
      bg="brand.50"
      px={{ base: 6, lg: 10 }}
      py={{ base: 6, lg: 14 }}
      borderRadius={16}
      w="full"
      maxW={{ base: 'full', lg: 420 }}
      gap={5}
      minH="full"
    >
      <Text
        color="brand.500"
        fontSize="2xl"
        fontWeight="semibold"
        textAlign={{ base: 'center', lg: 'left' }}
      >
        {t('myProducts')}
      </Text>

      <Flex
        flexDir="column"
        bg="white"
        gap={5}
        p={{ base: 3, lg: 5 }}
        borderRadius={12}
      >
        {selectedPlans.map(plan => (
          <ProductItem
            key={plan.id}
            product={plan}
            onDelete={handleDeleteItem}
          />
        ))}

        {selectedPlans.length > 0 && <Divider borderWidth={0.5} />}

        <ProductTotal total={total} />
      </Flex>
    </Flex>
  );
};
